export const isLoading = (...fetching: boolean[]): boolean => {
  return fetching.some((status) => status);
};
